import styled from "styled-components";

// import { PageWrapper as PWFrgtPwd } from "Components/Pages/ForgotPassword/ForgotPassword.style";
// import { FormWrapper as FWLogin } from "Components/Pages/Login/Login.style";

export const PageWrapper = styled.div`
		font-family: "Outfit", sans-serif;

		form.reset_password_wrapper input {
			min-height: 47px !important;
			border: 1px solid #e9e9e9;
			border-radius: 10px;
			background-color: #f7f7f7;
		}
		form.reset_password_wrapper label.label {
			margin: 0;
		}
		.login_btn_divs {
			margin-top: 40px;
		}
`;

export const FormWrapper = styled.div``;

